import '../plugins/datepicker';
import FormValidation from '../components/FormValidation';

class Appuntamento {

	constructor() {

		this.$form = $('.Appuntamento__Form');
        this.$status = $('.Form__Status');
        this.$statusText = $('.Form__Status--sent');

		new FormValidation(this.$form, {
			ajax: true,
			inputClass: 'Form__Input',
			inputFocusClass: 'Form__Input--focus',
			inputNotValidClass: 'Form__Input--not-valid',
			submitButtonSelector: '.Form__Submit',
			onSubmit: () => {

                this.$status.removeClass('Form__Status--error');
				this.$form.find('.Form__Status--sending').show();
                this.$form.find('.Form__Input').removeClass('Form__Input--not-valid');

			},
			onSuccess: (data) => {

                this.$form.find('.Form__Status--sent').show();
				this.$form.find('.Form__Status--sending').hide();
                $('html,body').animate({scrollTop: this.$form.find('.Form__Status').offset().top - 100});

			},
			onError: (data) => {

                Object.keys(data.responseJSON).forEach(key => {

			        const message = data.responseJSON[key];
			        const field = this.$form.find(`[name="${key}"]`).closest('.Form__Input');
			        field.find('.Form__InputResponse').html(message);
			        field.addClass('Form__Input--not-valid');

                });

				// this.$form.find('.Form__Status--sent').show();
				this.$form.find('.Form__Status--sending').hide();

				console.log(this.$form.find('.Form__Input--not-valid').eq(0).offset().top);

				$('html,body').animate({scrollTop: this.$form.find('.Form__Input--not-valid').eq(0).offset().top - 100});

			}
		});

		$('.input-calendar').datepicker({
			language: 'it-IT',
			weekStart: 1,
			autoHide: true,
			// filter: (date) => {
			// 	if (date.getDay() === 1) {
			// 		return false; // Disable all Sundays
			// 	}
			// }
		});

	}

}

export default new Appuntamento();



// WEBPACK FOOTER //
// ./js/layouts/appuntamento.js